import { PROPOSAL_PLATFORM_USER_RECEIVER } from '../../../../../../forms/Multiplatform/MediaOrderForms/Proposals/ProposalSendDrawer/ProposalSendForm/fields'

export const getInitialValues = members => {
  return {
    [PROPOSAL_PLATFORM_USER_RECEIVER]: members[0]?.value || null
  }
}
